"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionToJSON = exports.TransactionFromJSONTyped = exports.TransactionFromJSON = exports.instanceOfTransaction = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Transaction interface.
 */
function instanceOfTransaction(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTransaction = instanceOfTransaction;
function TransactionFromJSON(json) {
    return TransactionFromJSONTyped(json, false);
}
exports.TransactionFromJSON = TransactionFromJSON;
function TransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'remainingAmount': !(0, runtime_1.exists)(json, 'remaining_amount') ? undefined : json['remaining_amount'],
        'dateTime': !(0, runtime_1.exists)(json, 'date_time') ? undefined : (new Date(json['date_time'])),
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'offerName': !(0, runtime_1.exists)(json, 'offer_name') ? undefined : json['offer_name'],
        'offerId': !(0, runtime_1.exists)(json, 'offer_id') ? undefined : json['offer_id'],
        'offerExpirationTime': !(0, runtime_1.exists)(json, 'offer_expiration_time') ? undefined : (new Date(json['offer_expiration_time'])),
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.TransactionFromJSONTyped = TransactionFromJSONTyped;
function TransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'amount': value.amount,
        'remaining_amount': value.remainingAmount,
        'date_time': value.dateTime === undefined ? undefined : (value.dateTime.toISOString()),
        'ad_set_id': value.adSetId,
        'offer_name': value.offerName,
        'offer_id': value.offerId,
        'offer_expiration_time': value.offerExpirationTime === undefined ? undefined : (value.offerExpirationTime.toISOString()),
        'currency': value.currency,
    };
}
exports.TransactionToJSON = TransactionToJSON;
